import ClassicUpgrade from "../../../model/upgrade/classic/ClassicUpgrade";
import ClassicUpgradeCollection from "../../../model/upgrade/classic/ClassicUpgradeCollection";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import ClassicUpgradeView from "./ClassicUpgradeView";

export default class ClassicUpgradeCollectionView extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     * @param {ClassicUpgradeCollection} upgradeCollection
     */
    constructor(parentId, elementId, upgradeCollection) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {ClassicUpgradeCollection}
         */
        this.upgradeCollection = upgradeCollection;

        /**
         * @constant
         * @type {ClassicUpgradeView[]}
         */
        this.upgradeViews = [];

        /**
         * Used to generate unique IDs for the children.
         * @type {number}
         */
        this.idSequence = 0;

        const upgrades = this.upgradeCollection.upgrades;
        for (let i = 0; i < upgrades.length; i++) {
            /**
             * @type {ClassicUpgrade}
             */
            const upgrade = upgrades[i];
            if (!upgrade || !upgrade.isVisible()) {
                continue;
            }

            const upgradeView = this.createUpgradeView(upgrades[i]);

            this.upgradeViews.push(upgradeView);
            this.addView(upgradeView);
        }
    }

    /**
     * @returns {number}
     */
    getNextId() {
        return ++this.idSequence;
    }

    /**
     * @override
     */
    initializeView() {

        // <div id="pickUpgradesPanel" class="primary-upgrade-panel-body" style="display: none;"></div>

        const parent = Page.getElement(this.parentId);
        Page.createElement('div', parent, this.elementId, null); // 'primary-upgrade-panel-body'

        super.initializeView();
    }

    /**
     * @override
     */
    updateViewContents() {

        const upgrades = this.upgradeCollection.upgrades;
        let i = 0;
        let j = 0;

        for (; i < upgrades.length && j < this.upgradeViews.length; i++) {
            /**
             * @type {ClassicUpgrade}
             */
            const upgrade = upgrades[i];

            if (!upgrade || !upgrade.isVisible()) {
                continue;
            }

            this.upgradeViews[j].setClassicUpgrade(upgrade);
            j++;
        }

        if (i < upgrades.length) {
            // Add views for newly visible upgrades
            for (; i < upgrades.length; i++) {
                /**
                 * @type {ClassicUpgrade}
                 */
                const upgrade = upgrades[i];
                if (!upgrade || !upgrade.isVisible()) {
                    continue;
                }

                const upgradeView = this.createUpgradeView(upgrades[i]);

                this.upgradeViews.push(upgradeView);
                this.addView(upgradeView);

                // We need to initialize the view.
                upgradeView.initializeView();
            }
        }
        else if (j < this.upgradeViews.length) {
            // Clear out any extra upgrade views
            for (; j < this.upgradeViews.length; j++) {
                this.upgradeViews[j].setClassicUpgrade(null);
            }
        }

        super.updateViewContents();
    }

    /**
     * 
     * @param {ClassicUpgrade} upgrade 
     * @returns {ClassicUpgradeView}
     */
    createUpgradeView(upgrade) {
        return new ClassicUpgradeView(this.elementId, this.elementId + '_' + this.getNextId(), upgrade, false);
    }
}